import common from './common';
import filters from './filters';

export default {
    common,
    filters,
};